import { render, staticRenderFns } from "./SettingVisitReason.vue?vue&type=template&id=198c1ead&scoped=true&"
import script from "./SettingVisitReason.vue?vue&type=script&lang=js&"
export * from "./SettingVisitReason.vue?vue&type=script&lang=js&"
import style0 from "./SettingVisitReason.vue?vue&type=style&index=0&id=198c1ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c1ead",
  null
  
)

export default component.exports